import { Collapse } from '@material-ui/core';
import clsx from 'clsx';
import { Icon } from 'copilot-design-system';
import { CSSProperties, PropsWithChildren, useEffect, useState } from 'react';

import {
  SidebarListItemContainer,
  SidebarListItemIcon,
  SidebarListItemIconProps,
  SidebarListItemText,
} from 'src/components/sidebar/sidebar-items/SidebarListItem';
import { useMediaQuery } from 'src/hooks/useMediaQuery';

const CaretDownIcon = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => <Icon className={className} style={style} icon="CaretDown" />;

const FolderOpenIndicator = ({
  className,
  isOpen,
}: {
  className?: string;
  isOpen: boolean;
}) => (
  <SidebarListItemIcon
    className={className}
    IconElement={CaretDownIcon}
    iconSettings={{
      className: clsx(
        'transition-transform duration-200',
        isOpen ? 'rotate-0' : '-rotate-90',
      ),
    }}
  />
);

interface SidebarFolderItemProps
  extends Partial<Pick<SidebarListItemIconProps, 'IconElement'>> {
  htmlId: string;
  label: string;
  isOpen: boolean;
}

export const SidebarFolderItem = ({
  htmlId,
  label,
  IconElement,
  isOpen,
  children,
}: PropsWithChildren<SidebarFolderItemProps>) => {
  const isSmallMobile = useMediaQuery('xs', 'max');
  const [isFolderOpen, setIsFolderOpen] = useState(isOpen);
  useEffect(() => {
    setIsFolderOpen(isOpen);
  }, [isOpen]);

  return (
    <>
      <div className="group">
        <SidebarListItemContainer
          htmlId={htmlId}
          handleClick={() => setIsFolderOpen((prev) => !prev)}
        >
          {IconElement && (
            <>
              <SidebarListItemIcon
                className={clsx(
                  'min-w-6 flex',
                  !isSmallMobile && 'group-hover:hidden',
                )}
                IconElement={IconElement}
              />
              {!isSmallMobile && (
                <FolderOpenIndicator
                  className="min-w-6 hidden group-hover:flex"
                  isOpen={isFolderOpen}
                />
              )}
            </>
          )}
          <SidebarListItemText className="grow-0" text={label} />
          {isSmallMobile && (
            <FolderOpenIndicator
              className="ml-1.5 min-w-0"
              isOpen={isFolderOpen}
            />
          )}
        </SidebarListItemContainer>
      </div>
      <Collapse
        classes={{ wrapper: '-my-2' }}
        appear={false} // disable animation on first mount
        enter={false} // disable enter animation
        exit={false} // disable exit animation
        in={isFolderOpen}
        timeout="auto"
        unmountOnExit
      >
        {children}
      </Collapse>
    </>
  );
};
